import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../services/authentification.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
    constructor(private authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        request = request.clone({
            withCredentials: true
        });
        // add authorization header with jwt token if available
        const currentUser = this.authenticationService.currentUserValue;
        if (currentUser && currentUser.token) {
          if (request.headers.get('file') == null) {
            request = request.clone({
              setHeaders: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${currentUser.token}`
              }
            });
          } else {
            request.headers.delete('file');
            request = request.clone({
              setHeaders: {
                Authorization: `Bearer ${currentUser.token}`
              }
            });
          }
        }
        return next.handle(request);
    }
}
